import { useState } from 'react'

import { USERS_ACCESS_ANALYTICS } from '../../constants/usersAccess'
import { useLightMode } from '@/hooks/useLightMode'
import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

import { ActionMenu, Button } from '@hivewatch/dark'

import { trackEvent } from '@/utils/analytics'

import { CreateUsersAccessTechnicianModal } from './CreateUsersAccessTechnicianModal'
import { InviteTeamMemberModal } from './InviteTeamMemberModal'

type ActiveCreateModal = 'invite-user' | 'create-technician' | null

export const UsersAccessCreateAction = () => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { shouldEnableCreateTechnician, shouldEnableCreateUser } =
    usePermissions()
  const [activeModal, setActiveModal] = useState<ActiveCreateModal>(null)

  if (!shouldEnableCreateUser && !shouldEnableCreateTechnician) return null

  const items = [
    ...(shouldEnableCreateUser
      ? [
          {
            'data-testid': 'usersAccess_inviteUser',
            key: 'invite-user',
            label: t('settings:rebrand_users_invite_action'),
            onClick: () => {
              trackEvent(USERS_ACCESS_ANALYTICS.inviteOpened)
              setActiveModal('invite-user')
            },
          },
        ]
      : []),
    ...(shouldEnableCreateTechnician
      ? [
          {
            'data-testid': 'usersAccess_createTechnician',
            key: 'create-technician',
            label: t('settings:rebrand_users_create_technician_title'),
            onClick: () => {
              trackEvent(USERS_ACCESS_ANALYTICS.createTechnicianOpened)
              setActiveModal('create-technician')
            },
          },
        ]
      : []),
  ]

  return (
    <>
      <ActionMenu
        anchorRight
        colorScheme={colorScheme}
        fontSize='15px'
        itemLineHeight='20px'
        itemPadding='12px'
        items={items}
        minWidth='240px'
        trigger={({ onClick }) => (
          <Button
            colorScheme={colorScheme}
            data-testid='usersAccess_addTeamMember'
            onClick={onClick}
            size='md'
            style={{ minWidth: '200px' }}
          >
            {t('settings:rebrand_users_add_button')}
          </Button>
        )}
      />
      {activeModal === 'invite-user' && (
        <InviteTeamMemberModal
          colorScheme={colorScheme}
          isOpen
          onClose={() => setActiveModal(null)}
        />
      )}
      {activeModal === 'create-technician' && (
        <CreateUsersAccessTechnicianModal
          colorScheme={colorScheme}
          isOpen
          onClose={() => setActiveModal(null)}
        />
      )}
    </>
  )
}
